import React, { useEffect, useState } from "react";
import "./Cart.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  removeItem,
  resetCart,
  updateQuantity,
  validateCart,
} from "../../redux/cartReducer";
import "react-toastify/dist/ReactToastify.css";

const Cart = ({ closeCart }) => {
  const products = useSelector((state) => state.cart.products);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCheckout, setIsCheckout] = useState(false);
  const delivaryAmout = 20;
  const delivaryAmoutLess = 10;
  const noDelivaryAmout = 0;

  const totalPrice = () => {
    let total = 0;
    products.forEach((item) => (total += item.quantity * item.price));
    return total.toFixed(2);
  };

  const netOder = Math.min(totalPrice());
  const withDelivaryCost = () => {
    if (netOder < 50) {
      const netTotal = netOder + delivaryAmout;
      return netTotal.toFixed(2);
    }
    if (netOder >= 50 && netOder < 75) {
      const netTotal = netOder + delivaryAmoutLess;
      return netTotal.toFixed(2);
    }
    if (netOder >= 75) {
      const netTotal = netOder + noDelivaryAmout;
      return netTotal.toFixed(2);
    } else {
      return;
    }
  };

  const finalCost = withDelivaryCost();
  let FinalNetPrice = withDelivaryCost();

  const massageDisplay_75 = () => {
    if (netOder < 75) {
      let value = 75 - netOder;
      return ` You're just AED ${value.toFixed(2)} away from free delivery! `;
    } else {
      return " 🥳  Woo.. hoo.. you're eligible for free delivery 🚚 ";
    }
  };

  const massgeDisplay_50 = () => {
    if (netOder < 50) {
      let valueTwo = 50 - netOder;
      return ` Or,Add just AED ${valueTwo.toFixed(
        2
      )} to slash your delivery fee to AED 10.`;
    } else {
      return;
    }
  };

  const comMessage = " 'Don't miss out—shop a little more and save big! ";
  const inital = netOder === 0 ? "hide" : "";

  useEffect(() => {
    const now = new Date();

    products.forEach((item) => {
      if (item.flashSale === "yes" && item.flashEndDate && item.flashEndTime) {
        // Ensure time has seconds
        let time = item.flashEndTime;
        if (time.length === 5) time += ":00"; // add seconds if missing

        // Combine date + time
        const flashEndDateTime = new Date(`${item.flashEndDate}T${time}`);

        if (!isNaN(flashEndDateTime) && flashEndDateTime < now) {
          // Flash sale expired → update price
          if (item.price !== item.originalPrice) {
            dispatch(
              updateQuantity({
                id: item.id,
                quantity: item.quantity,
                price: item.originalPrice,
              })
            );
          }
        }
      }
    });
  }, [products, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(validateCart());
    }, 1000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const handleCheckout = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "begin_checkout",
      items: products.map((p) => ({
        item_id: p.id,
        item_name: p.name,
        price: p.price,
        flashPrice:p.flashPrice,
        quantity: p.quantity,
      })),
      currency: "AED",
      value: finalCost,
    });

    if (window.fbq) {
      window.fbq("track", "InitiateCheckout", {
        value: finalCost,
        currency: "AED",
        contents: products.map((p) => ({
          id: p.id,
          quantity: p.quantity,
          item_name: p.name,
          price: p.price,
        })),
        content_type: "product",
      });
    }

    closeCart();
    navigate("/check_out", { state: { products, finalCost } });
  };

  const handleExplore = () => {
    closeCart();
    navigate("/shop");
  };

  return (
    <div className="__fw">
      {!isCheckout && (
        <div className="cart">
          <div className="cart_wrap" style={{ padding: "10px" }}>
            <h2 className="cart-head">
              Product <em>in your cart</em>{" "}
            </h2>

            {products?.map((item, i) => (
              <div className="item" key={i}>
                <img
                  src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.img}`}
                  alt={item.name}
                />

                <div className="details">
                  <div className="top">
                    <strong>
                      {item.name?.length > 20
                        ? item.name.substring(0, 20) + "..."
                        : item.name}{" "}
                      - {item.weight}
                    </strong>
                  </div>

                  <div className="bottom">
                    <span className="price">
                      Qty {item.quantity} x AED {item.price} ={" "}
                      {item.quantity * item.price}
                    </span>

                    <div className="quantity-controls">
                      {/* Decrease button */}
                      <button
                        onClick={() =>
                          dispatch(
                            updateQuantity({
                              id: item.id,
                              quantity:
                                item.quantity === 1 ? 1 : item.quantity - 1,
                            })
                          )
                        }
                        disabled={item.quantity === 1}
                      >
                        -
                      </button>
                      <strong>{item.quantity}</strong>
                      {/* Increase button with stock check */}
                      <button
                        onClick={() => {
                          // If flash sale and flashMaxPcs > 0, enforce max quantity
                          if (
                            item.flashSale === "yes" &&
                            item.flashMaxPcs > 0
                          ) {
                            if (
                              item.quantity < item.flashMaxPcs &&
                              item.quantity < item.stock
                            ) {
                              dispatch(
                                updateQuantity({
                                  id: item.id,
                                  quantity: item.quantity + 1,
                                })
                              );
                            } else {
                              import("react-toastify").then(({ toast }) =>
                                toast.warning(
                                  `Maximum ${item.flashMaxPcs} pcs allowed for flash sale product`
                                )
                              );
                            }
                          } else {
                            // Normal behavior: check stock only
                            if (item.quantity < item.stock) {
                              dispatch(
                                updateQuantity({
                                  id: item.id,
                                  quantity: item.quantity + 1,
                                })
                              );
                            } else {
                              import("react-toastify").then(({ toast }) =>
                                toast.warning(
                                  `Only ${item.stock} pcs available`
                                )
                              );
                            }
                          }
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                <DeleteOutlinedIcon
                  className="delete"
                  onClick={() => dispatch(removeItem(item.id))}
                />
              </div>
            ))}

            <div className="total">
              <span>Products Total</span>
              <span>AED {totalPrice()}</span>
            </div>
            <div className="total">
              <span>Delivery Charges</span>
              {netOder < 50 ? (
                <p>AED 20.00</p>
              ) : netOder >= 50 && netOder < 75 ? (
                <p>AED 10.00</p>
              ) : (
                <p>Free</p>
              )}
            </div>
            <div className="sub_total">
              <span>SUBTOTAL</span>
              <div className={`${netOder === 0 ? "hide" : ""}`}>
                <span>AED {FinalNetPrice}</span>
              </div>
            </div>
            <div className="delivaryMsg">
              <p>
                <em>{massageDisplay_75()}</em>
                <em>{massgeDisplay_50()}</em>
                Don't miss out—shop a little more and save big!
              </p>
            </div>
            {products.length === 0 ? (
              <button className="checkout" onClick={handleExplore}>
                Cart empty — Explore now!
              </button>
            ) : (
              <button className="checkout" onClick={handleCheckout}>
                PROCEED TO CHECKOUT
              </button>
            )}
            <span className="reset" onClick={() => dispatch(resetCart())}>
              Reset Cart
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
